import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation sharedInsightLoginMutation($input: SharedInsightLoginInput!) {
		sharedInsightLogin(input: $input) {
			viewer {
				id
			}
			errors
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Shared Insight Login');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {...input}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
